const customers = [
  {
    id: 1,
    name: "Darsh Shah",
    email: "darsh@roundtechsquare.com",
  },
  {
    id: 2,
    name: "Hittarth Solanki",
    email: "hittarth@roundtechsquare.com",
  },
  {
    id: 3,
    name: "Vimal Patel",
    email: "vimal@roundtechsquare.com",
  },
  {
    id: 4,
    name: "Dhvanan Kotecha",
    email: "dan@roundtechsquare.com",
  },
  {
    id: 5,
    name: "Anurag Shastri",
    email: "anurag@roundtechsquare.com",
  },
];

export default customers;
